module.exports = __webpack_public_path__ + "static/img/types_shxz.a208a93b.png";